export enum LogLevel {
    NONE,
    ERROR,
    INFO,
    WARN,
    TRACE,
    DEBUG,
}

export interface Logger {
    level: LogLevel;
    info: typeof console['log'];
    warn: typeof console['warn'];
    error: typeof console['error'];
    debug: typeof console['debug'];
    trace: typeof console['trace'];
}

function noop() {
  // Do nothing
}

class LoggerImpl implements Logger {
    private _level: LogLevel = LogLevel.INFO;

    public get level(): LogLevel {
        return this._level;
    }

    public set level(value: LogLevel) {
        this._level = value;
        this.update();
    }

    public info!: typeof console['log'];
    public warn!: typeof console['warn'];
    public error!: typeof console['error'];
    public debug!: typeof console['debug'];
    public trace!: typeof console['trace'];

    constructor() {
        this.update();
    }

    private bind<K extends keyof Console>(level: LogLevel, fn: K): Console[K] {
        if (this._level < level) {
            return noop as Console[K];
        }

        return console[fn];
    }

    private update(): void {
        this.info = this.bind(LogLevel.INFO, 'log');
        this.warn = this.bind(LogLevel.WARN, 'warn');
        this.error = this.bind(LogLevel.ERROR, 'error');
        this.debug = this.bind(LogLevel.DEBUG, 'debug');
        this.trace = this.bind(LogLevel.TRACE, 'trace');
    }
}

export const LOG: Logger = new LoggerImpl();
